import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/authed')({
  beforeLoad: async ({context}) => {
    // Wait for auth to finish loading before checking authentication
    if (context.auth.isLoading) {
      return;
    }

    if (!context.auth.isAuthenticated) {
      // Trigger MSAL login popup
      await context.auth.login();
    }
  },
  component: Authed,
});

function Authed() {
  return <Outlet/>;
}